import mobx, { extendObservable, action } from 'mobx'
import axios from 'axios'
import { includes, map } from 'lodash'

class HomeStore {

    constructor() {
        extendObservable(this, {
            loading: true,
            counts: []    
        });
    }

    loadCount = () => {

        console.log('inside loadCount')
        this.loading = true;

        axios.get('/api/v1/home').then( ({data}) => {
            this.loading = false;
            this.counts = data;
           
            console.log('printing data:' || data);
            console.log(this.counts);

        });

    }

  
}

const store = new HomeStore();
export default store;



// WEBPACK FOOTER //
// ./src/store/home-store.js